import { render, staticRenderFns } from "./onebox-package_citizen.vue?vue&type=template&id=a295e50a&scoped=true&"
import script from "./onebox-package_citizen.vue?vue&type=script&lang=js&"
export * from "./onebox-package_citizen.vue?vue&type=script&lang=js&"
import style0 from "./onebox-package_citizen.vue?vue&type=style&index=0&id=a295e50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a295e50a",
  null
  
)

export default component.exports